import React from 'react';
import { Link } from 'react-router-dom';
import { Award, BookOpen, Heart, ShieldCheck } from 'lucide-react';
import { CERT_IMAGE, TEACHER_IMAGE } from '../data/mock';

export default function About() {
  return (
    <div className="fade-in">
      <section className="coral-gradient text-white relative overflow-hidden">
        <div className="absolute inset-0 dotted-bg opacity-60" />
        <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-20 lg:py-28">
          <div className="text-white/90 text-xs font-semibold uppercase tracking-[0.18em]">About RN Academy</div>
          <h1 className="font-serif font-semibold text-5xl md:text-6xl mt-4 leading-[1.05] max-w-4xl">
            A 60-year legacy of <span className="gold-text italic">academic excellence.</span>
          </h1>
          <p className="mt-6 text-white/90 text-lg max-w-2xl">
            The New Age Learning Solutions — disciplined, results-driven coaching for ICSE, CBSE & ISC students across Kolkata and Howrah.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-20 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <h2 className="font-serif text-4xl md:text-5xl font-semibold leading-tight">Our story</h2>
          <p className="text-stone-700 mt-5 leading-relaxed">
            Founded in Behala, Kolkata, RN Academy has grown into one of the most respected K-12 coaching institutions in West Bengal. Across two branches in Behala and Howrah, we serve students from Class 5 to Class 12 with structured, board-aligned preparation for ICSE, CBSE and ISC.
          </p>
          <p className="text-stone-700 mt-4 leading-relaxed">
            If you are searching for the best coaching centre in Behala or top tuition classes in Howrah, RN Academy stands as a benchmark of disciplined learning and results-driven preparation.
          </p>

          <div className="grid sm:grid-cols-3 gap-4 mt-10">
            {[
              { icon: Award, t: 'Excellence', d: 'Six decades of consistent results.' },
              { icon: ShieldCheck, t: 'Discipline', d: 'Structured study habits, every day.' },
              { icon: Heart, t: 'Care', d: 'Small batches, personal mentoring.' },
            ].map((b) => (
              <div key={b.t} className="bg-white rounded-2xl p-5 border border-orange-100 smooth card-hover">
                <div className="w-10 h-10 rounded-lg bg-coral-light text-coral flex items-center justify-center mb-3">
                  <b.icon className="w-5 h-5" />
                </div>
                <h3 className="font-serif font-semibold text-lg">{b.t}</h3>
                <p className="text-stone-600 text-sm mt-1.5">{b.d}</p>
              </div>
            ))}
          </div>
          <Link to="/admissions" className="inline-flex mt-8 btn-primary smooth font-medium px-6 py-3 rounded-xl">Apply for Admission</Link>
        </div>
        <div className="rounded-3xl overflow-hidden shadow-2xl border-4 border-white">
          <img src={CERT_IMAGE} alt="RN Academy faculty and students" className="w-full h-[560px] object-cover" />
        </div>
      </section>

      <section className="bg-[#fff1ea]">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 grid lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1 rounded-3xl overflow-hidden shadow-2xl">
            <img src={TEACHER_IMAGE} alt="RN Academy faculty teaching" className="w-full h-[480px] object-cover" />
          </div>
          <div className="order-1 lg:order-2">
            <div className="text-coral text-xs font-semibold uppercase tracking-[0.18em]">Our Mission</div>
            <h2 className="font-serif text-4xl md:text-5xl font-semibold mt-3 leading-tight">Mentoring that lasts a <span className="italic text-amber-600">lifetime.</span></h2>
            <p className="text-stone-700 mt-5 leading-relaxed">
              At RN Academy we believe coaching is not just about exam preparation — it is about building lifelong learners. Our faculty mentor every student personally, balancing academic rigour with care.
            </p>
            <ul className="mt-6 space-y-3">
              {[
                'Concept-first teaching, not rote memorisation',
                'Regular tests and personal feedback to parents',
                'Board-aligned curriculum from Class 5 to 12',
                'A culture of discipline, respect and curiosity',
              ].map((b) => (
                <li key={b} className="flex gap-3 items-start">
                  <span className="mt-1 w-5 h-5 rounded-full bg-coral text-white flex items-center justify-center text-[0.7rem]">✓</span>
                  <span className="text-stone-700">{b}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}
